export default __webpack_public_path__ + "img/475a4f9c36c526498b4358bb6772ce25.svg";